import { render, staticRenderFns } from "./ProductCampaignCharts.vue?vue&type=template&id=ed2e7246"
import script from "./ProductCampaignCharts.vue?vue&type=script&lang=js"
export * from "./ProductCampaignCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports